import { InvestmentCompletionStatus } from 'further-types/investment';
import { InvestmentArchiveStatus } from 'further-types/investment';

export enum DisplayFilterOption {
  ShowUnarchived = 'show_unarchived',
  ShowArchived = 'show_archived',
  ShowComplete = 'show_complete',
  ShowIncomplete = 'show_incomplete',
  ShowAdvisedApplications = 'show_advised_applications',
}

export const DISPLAY_FILTER_OPTIONS = [
  { label: 'Show unarchived', value: DisplayFilterOption.ShowUnarchived },
  { label: 'Show archived', value: DisplayFilterOption.ShowArchived },
  { label: 'Show complete', value: DisplayFilterOption.ShowComplete },
  { label: 'Show incomplete', value: DisplayFilterOption.ShowIncomplete },
  {
    label: 'Show advised applications',
    value: DisplayFilterOption.ShowAdvisedApplications,
  },
];

export const STATUS_OPTIONS = [
  { label: 'Show all', value: InvestmentCompletionStatus.All },
  { label: 'Completed', value: InvestmentCompletionStatus.Completed },
  { label: 'Incomplete', value: InvestmentCompletionStatus.Incomplete },
];

export const ARCHIVE_OPTIONS = [
  { label: 'Show all', value: InvestmentArchiveStatus.All },
  { label: 'Not archived', value: InvestmentArchiveStatus.NotArchived },
  { label: 'Archived', value: InvestmentArchiveStatus.Archived },
];

export const STEPS_MAP = {
  1: 'Appropriateness (1/5)',
  2: 'KYC (2/5)',
  3: 'Bank and tax details (3/5)',
  4: 'Subscription selection (4/5)',
  5: 'Manual payment (5/5)',
  6: 'Open Banking (5/5)',
};
